import React, { useEffect, useState } from "react";
import Intro from "../components/Intro";
import Search from "../components/Search";
import Card from "../components/Card";

const url = "https://www.omdbapi.com/?i=tt3896198&apikey=3efee69e";
const Home = () => {
  const [loading, setLoading] = useState(true);
  const [findMovies, setFindMovies] = useState([]);

  const searchMovies = async (title) => {
    const response = await fetch(`${url}&s=${title}`);
    const data = await response.json();
    setLoading(false);
    setFindMovies(data.Search);
    console.log(findMovies);
  };

  useEffect(() => {
    searchMovies("shrek");
  }, []);

  return (
    <>
      <section className="home container">
        <Intro />
        <Search searchMovies={searchMovies} />
        {loading ? (
          <div className="loader"></div>
        ) : (
          <div className="cards container">
            {findMovies?.length > 0 ? (
              findMovies.map((movie) => (
                <Card key={movie.imdbID} movie={movie} />
              ))
            ) : (
              <p className="notFound">Movies Not Found</p>
            )}
          </div>
        )}
      </section>
    </>
  );
};
export default Home;
